import qs from 'qs';
import { ADMIN_SCOPED_ROLES, getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { Meta } from '../communication/types/Meta';
import { UserProfile } from './types/UserProfile';

export interface IListCA {
  nodes: UserProfile[];
  meta: Meta;
}

export interface IListCAParams {
  limit?: number;
  sort_by?: 'created_at' | 'updated_at';
  sort_direction?: 'asc' | 'desc';
  cursor?: string;
  cursor_direction?: 'next' | 'previous';
  case_id?: number;
}

export const listAllCareAdvisors = async (params?: IListCAParams, userRole?: string): Promise<IListCA> => {
  const prefix = userRole ? (ADMIN_SCOPED_ROLES.has(userRole) ? '/admin' : getStaffScopedApiPrefix(userRole)) : '';
  const { data } = await client.get<IListCA>(`${prefix}/care_advisors?${qs.stringify(params, { skipNulls: true })}`);

  return data;
};
